// Import de funcions auxiliars
import {
    obteVariable,
    obteValorVariable,
    afegeixErrorAVariable
}  from './utils';

/*
 * Per facilitar la lectura del codi s'afegeixen els identificadors de variables a mode de constants
 * NOTA: Les hores de pluja es poden informar de dues maneres:
 *       - Informar només el total d'hores del dia civil.
 *       - Informar totes les franges temporals i que el sumatori coincideixi amb el total d'hores del dia civil.
 ***/
export const ID_PRECIPITACIO_TOTAL_DARRERES_24H_DIA_PLUVIOMETRIC = 34;
export const ID_PRECIPITACIO_TOTAL_DARRERES_24H_DIA_CIVIL = 35;
export const ID_PRECIPITACIO_ENTRE_00_I_07H = 36;
export const ID_PRECIPITACIO_ENTRE_07_I_13H = 37;
export const ID_PRECIPITACIO_ENTRE_13_I_18H = 38;
export const ID_PRECIPITACIO_ENTRE_18_I_24H = 39;

/*
 * Missatges d'error propis del grup
 ***/
export const MSG_SI_ALGUNA_FRANJA_HORES_PRECIPITACIO_INFORMADA_ALESHORES_TOTES_FRANGES_INFORMADES = 'S\'han d\'informar totes les franges temporals de precipitació o no informar-ne cap.';
export const MSG_PRECIPITACIO_DIA_PLUVIOMETRIC_OBLIGATORIA = 'La precipitació total darreres 24h (dia pluviomètric) és obligatòria.';

/*
 * Funcions auxiliars que ajuden a la legibilitat
 ***/
const estanFrangesHoresPrecipitacioIncompletes = (horesDePrecipitacioFrangesValor) => {
    const hiHaAlgunaFranjaNoInformada = horesDePrecipitacioFrangesValor.some(horesDePrecipitacioFranjaValor => horesDePrecipitacioFranjaValor === null);
    const hiHaAlgunaFranjaInformada = horesDePrecipitacioFrangesValor.some(horesDePrecipitacioFranjaValor => horesDePrecipitacioFranjaValor !== null);
    return hiHaAlgunaFranjaInformada && hiHaAlgunaFranjaNoInformada;
};

const checkPrecipitacioDiaPluviometricObligatoria = (precipitacioDiaPluviometricValor) => {
    return precipitacioDiaPluviometricValor !== 0 && !precipitacioDiaPluviometricValor;
};

/*
 * Grup Precipitació
 ***/
export const checkGrupPrecipitacio = (nouVariables) => {

    // Variables
    const precipitacioDiaPluviometric = obteVariable(ID_PRECIPITACIO_TOTAL_DARRERES_24H_DIA_PLUVIOMETRIC, nouVariables);
    const precipitacioDiaCivil = obteVariable(ID_PRECIPITACIO_TOTAL_DARRERES_24H_DIA_CIVIL, nouVariables);
    const precipitacioEntre00i07 = obteVariable(ID_PRECIPITACIO_ENTRE_00_I_07H, nouVariables);
    const precipitacioEntre07i13 = obteVariable(ID_PRECIPITACIO_ENTRE_07_I_13H, nouVariables);
    const precipitacioEntre13i18 = obteVariable(ID_PRECIPITACIO_ENTRE_13_I_18H, nouVariables);
    const precipitacioEntre18i24 = obteVariable(ID_PRECIPITACIO_ENTRE_18_I_24H, nouVariables);

    if (precipitacioDiaCivil && precipitacioEntre00i07 &&
        precipitacioEntre07i13 && precipitacioEntre13i18 && precipitacioEntre18i24) {

        // Valors de variables
        const precipitacioEntre00i07Valor = obteValorVariable(precipitacioEntre00i07);
        const precipitacioEntre07i13Valor = obteValorVariable(precipitacioEntre07i13);
        const precipitacioEntre13i18Valor = obteValorVariable(precipitacioEntre13i18);
        const precipitacioEntre18i24Valor = obteValorVariable(precipitacioEntre18i24);

        // Arrays auxiliars amb les diferents variables/valors de franges d'hores
        const horesDePrecipitacioFranges = [precipitacioEntre00i07, precipitacioEntre07i13, precipitacioEntre13i18, precipitacioEntre18i24];
        const horesDePrecipitacioFrangesValor = [precipitacioEntre00i07Valor, precipitacioEntre07i13Valor, precipitacioEntre13i18Valor, precipitacioEntre18i24Valor];

        if (estanFrangesHoresPrecipitacioIncompletes(horesDePrecipitacioFrangesValor)) {
            // Si una franja horaria està informada la resta també ho han d'estar. O totes o cap.
            // Afegim error a totes les franges
            horesDePrecipitacioFranges.forEach(horesDePrecipitacioFranja => {
                afegeixErrorAVariable(horesDePrecipitacioFranja, MSG_SI_ALGUNA_FRANJA_HORES_PRECIPITACIO_INFORMADA_ALESHORES_TOTES_FRANGES_INFORMADES);
            });
        }
    }

    if (precipitacioDiaPluviometric) {
        const precipitacioDiaPluviometricValor = obteValorVariable(precipitacioDiaPluviometric);
        // La variable Precipitació total darreres 24h (dia pluviomètric) és obligatòria
        if (checkPrecipitacioDiaPluviometricObligatoria(precipitacioDiaPluviometricValor) && !precipitacioDiaPluviometric.esValorInapreciable) {
            afegeixErrorAVariable(precipitacioDiaPluviometric, MSG_PRECIPITACIO_DIA_PLUVIOMETRIC_OBLIGATORIA);
        }
    }

};



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/filtresCoherencia/grupPrecipitacio.js